/** Wraps a generated QR blob into a PNG File suitable for the editor upload pipeline. */
export default function qrBlobToFile(blob: Blob, name: string): File {
  const base = name.trim() || 'qr-code';
  const fileName = base.toLowerCase().endsWith('.png') ? base : `${base}.png`;
  return new File([blob], fileName, { type: 'image/png' });
}
